export enum OpcaoGatilhoAutomacaoOrdemServicoEnum {
  TransicaoStatus = 1,
  EventoFiscal = 2,
}
